import React from 'react'
import { IncomingDropzoneProvider } from 'view/shared/incomingUpload'
import { CurveUploadDialogProps } from './constants'

export const CurveGridDropzoneProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <IncomingDropzoneProvider uploadDialogProps={CurveUploadDialogProps}>{children}</IncomingDropzoneProvider>
)
